import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { startCanvasZoom } from './shell/canvasZoom';
import './styles/tokens.css';
import './styles/base.css';

startCanvasZoom();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
